import React, { type ReactNode } from "react";
import { Badge } from "react-bootstrap";
import { ColumnConfig } from "../types";
import { formatAmount, formatDate, getStatusStyle } from "./utils";

export const formatCellValue = <T,>(
  column: ColumnConfig,
  row: T
): ReactNode => {
  const value: unknown = (row as any)?.[column.field];

  if (column.isAmount && typeof value === "number") {
    return formatAmount(value);
  }

  if (column.isDate && typeof value === "string") {
    return formatDate(value);
  }

  if (column.isStatus && typeof value === "string") {
    const style = getStatusStyle(value);
    return (
      <Badge bg={style.variant} className={style.className}>
        {style.text}
      </Badge>
    );
  }

  if (typeof value === "object" && value !== null) {
    if ("name" in value) {
      return value.name as string;
    }

    return JSON.stringify(value);
  }

  if (React.isValidElement(value)) return value;

  if (typeof value === "string" || typeof value === "number") return value;

  if (typeof value === "boolean") return value ? "Yes" : "No";

  // null/undefined/anything else
  return "-";
};
